import {Repository} from "@api/repositories/Repository";
import {AxiosInstance} from "axios";
import {WebConferenceJoinResult} from "@api/models/web-conferences/WebConferenceJoinResult";
import {StreamInfo} from "@share/web-conferences/types/StreamInfo";
import {CurrentPresentation} from "@api/models/interfaces/web-conference/CurrentPresentation";
import {AgoraTestCredentials} from "@api/models/interfaces/web-conference/AgoraTestCredentials";

export class WebConferenceRepository implements Repository {
    client: AxiosInstance;

    constructor(client: AxiosInstance) {
        this.client = client;
    }

    join(schemaId: string, objectId: string) {
        return this.client.post<WebConferenceJoinResult>(`/webConferences/${schemaId}/${objectId}/join`)
            .then(({data}) => {
                return data ? new WebConferenceJoinResult(data) : null;
            });
    }

    ban(schemaId: string, objectId: string, userId: number): Promise<boolean> {
        return this.client.post(`/webConferences/${schemaId}/${objectId}/ban`, userId)
            .then(({ status }) =>{
                return status === 200;
            });
    }

    addPresenter(schemaId: string, objectId: string, userId: number) {
        return this.client.post(`/webConferences/${schemaId}/${objectId}/presenters`, userId);
    }

    deletePresenter(schemaId: string, objectId: string, userId: number) {
        return this.client.delete(`/webConferences/${schemaId}/${objectId}/presenters`, {
            data: userId
        });
    }

    raiseHand(schemaId: string, objectId: string) {
        return this.client.post(`/webConferences/${schemaId}/${objectId}/raiseHand`);
    }

    lowerHand(schemaId: string, objectId: string) {
        return this.client.post(`/webConferences/${schemaId}/${objectId}/lowerHand`);
    }

    streamStatus(schemaId: string, objectId: string, body: StreamInfo) {
        return this.client.put(`webConferences/${schemaId}/${objectId}/streamStatus`, body)
    }

    changePresentation(schemaId: string, objectId: string, body: CurrentPresentation | null) {
        return this.client.put<CurrentPresentation>(`/webConferences/${schemaId}/${objectId}/presentation`, body)
            .then(({data}) => data);
    }

    getTestCredentials() {
        return this.client.post<AgoraTestCredentials>(`/webConferences/networkTest/query`)
            .then(({data}) => data);
    }
}
